export const userTabsTypes = {
  userTabsAddUser: 'userTabsAddUser',
  userTabsSetCurrentTab: 'userTabsSetCurrentTab',
}

// General for conversations
export const conversationsTypes = {
  removeOne: 'conversationsRemoveOne',
  removeAll: 'conversationsRemoveAll',
}

export const conversationAddressTypes = {
  display: 'conversationAddressDisplay',
  update: 'conversationAddressUpdate',
}

export const conversationPassengersTypes = {
  display: 'conversationPassengersDisplay',
  update: 'conversationPassengersUpdate',
}